import { Component, OnChanges, Input, ViewChild } from "@angular/core";
import { NgbNav } from "@ng-bootstrap/ng-bootstrap";

import { ApiService, } from "src/app/api.service";
import { APIResults } from "src/app/sharedinterfaces";
import { AdjustmentArchive } from "./adjustment-history/adjustment-history.component";

@Component({
	selector: "app-rtb",
	templateUrl: "./rtb.component.html",
	styleUrls: ["./rtb.component.scss"],
})
export class RtbComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	@ViewChild("nav") rtbTabs: NgbNav;

	public rotors: APIResults.Rotor[];
	public selectedRotor?: APIResults.Rotor;
	public adjustmentArchive: AdjustmentArchive;
	public regimes: APIResults.RegimeIndex;
	public vibecheck: APIResults.VibeCheck;

	constructor(public api: ApiService) { }

	async ngOnChanges(): Promise<void> {
		const { rotors, regimes, check } = await this.api.GetRTBConfig(this.asset.asset_id);
		this.rotors = rotors;
		this.regimes = regimes;
		this.vibecheck = check;
		if (this.rotors.length > 0) {
			this.rotorChange(this.rotors[0]);
		} else {
			this.rotorChange(undefined);
		}
	}

	async rotorChange(rotor?: APIResults.Rotor) {
		this.adjustmentArchive = undefined;
		this.selectedRotor = rotor;
	}

	RecordAdjustment(archive: AdjustmentArchive) {
		this.adjustmentArchive = archive;
		this.rtbTabs.select("tab-adjustment-history");
	}
}

